var clientDetailsMapper = function (AllClientDetails) {
    var result = {
        client: {},
        dpid: [],
        bankslist: [],
    };
    if (AllClientDetails) {
        var clientdetailslist = AllClientDetails.data.client;
        var details = {
            correspondenceAddress: clientdetailslist.correspondenceAdd,
            pdfFormPath: clientdetailslist.pdfFormPath,
            acCode: clientdetailslist.acCode,
            accName: clientdetailslist.acName,
            accType: clientdetailslist.acType,
            clientPlan: clientdetailslist.clientPlan,
            panNumber: clientdetailslist.pan,
            mobileNo: clientdetailslist.mobileNo,
            residenceAddress: clientdetailslist.residenceAdd,
            clientDob: clientdetailslist.birthDate,
            active: clientdetailslist.active,
            lob: clientdetailslist.lob,
            email: clientdetailslist.email,
        };
        result.client = details;
        var dpdata = AllClientDetails.data.dps.map(function (item) {
            return {
                dpName: item.dp_Name,
                dpAcc: item.dp_AcNo,
                dpId: item.dp_Id,
                depositoryType: item.dp_Type,
                poa: item.poa,
                dpddpiSw: item.dpddpiSw,
                acCode: item.acCode,
            };
        });
        result.dpid = dpdata;
        var bankdata = AllClientDetails.data.banks.map(function (item) {
            return {
                ifscCode: item.neftCode,
                bankName: item.bankName,
                bankAccNo: item.bankAccNo,
                acCode: item.acCode,
                micrNo: item.micrNo,
                bank_branch: item.bank_branch,
                accType: item.accType
            };
        });
        result.bankslist = bankdata;
    }
    return result;
};
export default clientDetailsMapper;
